export default __webpack_public_path__ + "static/media/black.e27080da.svg";